import * as React from 'react'

import { Box, Href, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import type { IncidenceOptionSection } from 'modules/payroll_bundle/hooks/useIncidenceOptionSections'

interface Props {
  incidenceOptionSections: IncidenceOptionSection[]
}

const MenuComponent = ({ incidenceOptionSections }: Props) => {
  const [selectedItem, setSelectedItem] = React.useState(0)
  const onClick = (key: number) => {
    const targetReference = incidenceOptionSections[key]?.sectionReference.current
    if (targetReference) {
      setSelectedItem(key)
      window.scrollTo(0, targetReference.offsetTop)
    }
  }

  return (
    <Box gap="s40">
      <Box gap="s16">
        <Icon.Large icon="esignature" color="radicalRed1000" />
        <Text.Header1>
          {i18n.t('app_store_v2.apps.payroll_bundle.settings.incidences.settings')}
        </Text.Header1>
        <Text.Normal weight="normal" color="grey1000" size="200">
          {i18n.t('app_store_v2.apps.payroll_bundle.settings.incidences.page_description')}
        </Text.Normal>
      </Box>
      <Href href={helpCenterUrl('payroll_incidences')} target="_blank">
        <Box gap="s12" flexDirection="row">
          <Text.Normal size="300" weight="medium" color="grey1000">
            {i18n.t('app_store_v2.apps.payroll_bundle.settings.incidences.learn_more')}
          </Text.Normal>
          <Icon.Medium icon="arrow-right" color="grey1000" />
        </Box>
      </Href>
    </Box>
  )
}

export default observer(MenuComponent)
